<template>
  <div class="goods-container">
    <pano-container v-if="xml" :xml="xml">
      <div class="page-title halo-fade-in" v-if="title">
        <div class="title-inner ellipsis">{{ title }}</div>
      </div>

      <good-list v-if="data.id" :list="list" :pano_id="nowPanoId" @select="selectService"></good-list>
    </pano-container>
  </div>
</template>

<script>
import useGoods from "@/composables/use-goods";

import PanoContainer from "@/components/pano-container";
import goodList from "./components/good-list";

export default {
  components: {
    PanoContainer,
    goodList,
  },
  setup() {
    const {
      alllist: list = [],
      nowPanoId,
      data = {},
      selectService,
      back,
      title,
      xml,
      panoDetail,
    } = useGoods();

    return {
      list,
      nowPanoId,
      data,
      selectService,
      back,
      title,
      xml,
      panoDetail,
    };
  },
  data() {
    return {
      visible: false,
      dVisible: false,
    };
  },
};
</script>

<style lang="less" scoped>
.goods-container {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: #3d3d3d;
}
.page-title {
  width: 750px;
  height: 92px;
  line-height: 92px;
  background: linear-gradient(
    90deg,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0.36) 51%,
    rgba(0, 0, 0, 0) 100%
  );
  text-align: center;
  color: white;
  font-size: 32px;
  font-weight: bold;
  position: fixed;
  top: 20px;
  left: 0;
  right: 0;
  margin: auto;
  .back-btn-wrap {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 30px;
  }
  .back-btn {
    width: 48px;
    height: 48px;
    cursor: pointer;
  }
  .title-inner {
    width: 80%;
    margin: auto;
  }
}
</style>
